<template>
  <div class="areaSelectFooter" :data-theme="themeMode">
    <el-button @click="goArea">
      <div class="icon-with-text" >
        <svg width="15" height="15" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_5103_32691)">
            <path
                d="M9.9915 1.89209C5.3915 1.89209 1.6665 5.62542 1.6665 10.2254C1.6665 14.8254 5.3915 18.5588 9.9915 18.5588C14.5998 18.5588 18.3332 14.8254 18.3332 10.2254C18.3332 5.62542 14.5998 1.89209 9.9915 1.89209ZM15.7665 6.89209H13.3082C13.0415 5.85042 12.6582 4.85042 12.1582 3.92542C13.6915 4.45042 14.9665 5.51709 15.7665 6.89209ZM9.99984 3.59209C10.6915 4.59209 11.2332 5.70042 11.5915 6.89209H8.40817C8.7665 5.70042 9.30817 4.59209 9.99984 3.59209ZM3.54984 11.8921C3.4165 11.3588 3.33317 10.8004 3.33317 10.2254C3.33317 9.65042 3.4165 9.09209 3.54984 8.55876H6.3665C6.29984 9.10876 6.24984 9.65876 6.24984 10.2254C6.24984 10.7921 6.29984 11.3421 6.3665 11.8921H3.54984ZM4.23317 13.5588H6.6915C6.95817 14.6004 7.3415 15.6004 7.8415 16.5254C6.30817 16.0004 5.03317 14.9421 4.23317 13.5588ZM6.6915 6.89209H4.23317C5.03317 5.50876 6.30817 4.45042 7.8415 3.92542C7.3415 4.85042 6.95817 5.85042 6.6915 6.89209ZM9.99984 16.8588C9.30817 15.8588 8.7665 14.7504 8.40817 13.5588H11.5915C11.2332 14.7504 10.6915 15.8588 9.99984 16.8588ZM11.9498 11.8921H8.04984C7.97484 11.3421 7.9165 10.7921 7.9165 10.2254C7.9165 9.65876 7.97484 9.10042 8.04984 8.55876H11.9498C12.0248 9.10042 12.0832 9.65876 12.0832 10.2254C12.0832 10.7921 12.0248 11.3421 11.9498 11.8921ZM12.1582 16.5254C12.6582 15.6004 13.0415 14.6004 13.3082 13.5588H15.7665C14.9665 14.9338 13.6915 16.0004 12.1582 16.5254ZM13.6332 11.8921C13.6998 11.3421 13.7498 10.7921 13.7498 10.2254C13.7498 9.65876 13.6998 9.10876 13.6332 8.55876H16.4498C16.5832 9.09209 16.6665 9.65042 16.6665 10.2254C16.6665 10.8004 16.5832 11.3588 16.4498 11.8921H13.6332Z"
                fill="#9E9E9E"></path>
          </g>
          <defs>
            <clipPath id="clip0_5103_32691">
              <rect width="20" height="20" fill="white" transform="translate(0,2)"></rect>
            </clipPath>
          </defs>
        </svg>

        <div class="text-container">
          <span>{{ $t('aAndL.' + localLanguage + '.Country') }}</span>
          <el-divider direction="vertical"></el-divider>
          <span>{{ $t('aAndL.' + localLanguage + '.Language') }}</span>
        </div>
      </div>
    </el-button>

  </div>
</template>

<script>

export default {
  data(){
    return{
      localLanguage:localStorage.getItem('locale')
    }
  },
  computed: {
    themeMode() {
      window.document.documentElement.setAttribute("data-theme", this.$store.state.subject === 'dark' ? 'dark' : 'light');
      return this.$store.state.subject === 'dark' ? 'dark' : 'light';
    },
  },
  methods:{
    goArea(){
      this.$router.push('/area/area')
    }
  }
}

</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';


.areaSelectFooter >>> .el-button {
  margin: 0;
  padding: 0;
  border: 0;
  @include font_color("areaSelectFooterColor");
  @include background_color("background_color");
}

.areaSelectFooter >>> .el-button:hover{
  @include background_color("areaSelectFooterHoverBgColor");
}

.icon-with-text {
  font-size: 12px;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

.text-container {
  display: flex;
  align-items: center;
  margin-left: 5px;
}


.text-container >>> .el-divider {
  @include font_color("areaSelectFooterColor");
}
</style>



// WEBPACK FOOTER //
// src/components/areaSelectFooter/areaSelectFooter.vue